import axios from 'axios'
// import store from '@/store'
import { urlEndWith } from '@/utility/utility'
// create axios
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API // api base_url
})

const err = (error) => {
  // const { status, data } = error.response
  // const { errors } = data
  // const message = []

  console.log(error.response)

  // for (const field in errors) {
  //   message.push(errors[field])
  // }
  // switch (status) {
  //   case 400:
  //     window._VMA.$emit('SHOW_SNACKBAR', {
  //       show: true,
  //       text: 'Bad Request ' + data.message,
  //       color: 'red'
  //     })
  //     break

  //   case 404:
  //     alert('404 not found')
  //     break

  //   case 422:
  //     window._VMA.$emit('SHOW_SNACKBAR', {
  //       show: true,
  //       text: message,
  //       color: 'red'
  //     })

  //     break

  //   case 401:
  //     window._VMA.$emit('AUTH_FAIELD')
  //     break

  //   case 403:
  //     window._VMA.$emit('ACESS_DENIED')
  //     break
  //   case 500:
  //     window._VMA.$emit('SERVER_ERROR')
  //     break

  //   default:
  //     break
  // }

  return Promise.reject(error)
}

// request interceptor

service.interceptors.request.use((req) => {
  // console.log('req : ', req)
  // console.log(urlEndWith(req.url))

  req.headers['Content-Type'] = 'application/json'
  if (urlEndWith(req.url) !== 'login') {
    req.headers.Authorization = 'Bearer ' + localStorage.getItem('access_token')
    // req.headers['Access-Control-Allow-Origin'] = '*'
  }

  return req
}, err)

// response interceptor

// eslint-disable-next-line no-unused-vars
service.interceptors.response.use(({ data, config }) => {
  // if (['put', 'post', 'delete', 'patch'].includes(config.method) && data.meta) {
  //   window._VMA.$emit('SHOW_SNACKBAR', {
  //     text: data.meta.message,
  //     color: 'success'
  //   })
  // }
  // if (data.error !== undefined) {
  //   window._VMA.$emit('API_FAILED', data.error)
  // }

  return data
}, err)

export default service
